<!-- 科研成果 成就页面 点击孵化合作调转至该页面 合作页面-->
<template>
  <div class="cooperation">
    <div class="nav clearfix">
      <div class="scienceNav" @click="gotoScience">科研成果</div>
      <div class="cooperationNav">
        孵化合作
        <div class="icon"></div>
      </div>
    </div>
    <van-list
      :immediate-check="false"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div
        class="card"
        v-for="item in list"
        :key="item.sId"
        @click="gotoCooperationDetail(item.sId)"
      >
        <div class="IconAndName clearfix">
          <div class="cardIconSchool" v-if="item.sSource == 1">高校需求</div>
          <div class="cardIcon" v-else>企业需求</div>
          <div class="cooperationName">{{ item.sCompanyName }}</div>
        </div>
        <div class="title">{{ item.sName }}</div>
        <div class="describe">目标产品：{{ item.sDescription }}</div>
        <div class="date">{{ item.sCreateTime }}</div>
      </div>
    </van-list>
    <div class="issue" @click="gotoIssue">发布</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      lastPage: "",
      list: [],
      loading: false,
      finished: false,
    };
  },
  created() {
    this.getCooperation();
  },
  methods: {
    async getCooperation() {
      const result = await this.$http.get("/achievementTransform/getAllNeedList", {
        params: { currentPage: this.page, perpage: this.pageSize },
      });
      for (let i = 0; i < result.data.list.length; i++) {
        this.list.push(result.data.list[i]);
      }
      this.lastPage = result.data.lastPage;
    },
    // 懒加载
    onLoad() {
      this.page = this.page + 1;
      this.getCooperation();
      this.loading = false;
      // 数据全部加载完成
      if (this.page >= this.lastPage) {
        this.finished = true;
      }
    },
    gotoIssue() {
      return this.$router.push("/addCooperation");
    },
    gotoScience() {
      window.history.back(-1);
    },
    gotoCooperationDetail(sId) {
      return this.$router.push({
        path: "/cooperationDetail",
        query: { sId: sId },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.cooperation {
  position: relative;
  min-height: 100vh;
  .nav {
    position: relative;
    left: 25%;
    width: 50%;
    margin-top: 15px;
    .cooperationNav {
      position: relative;
      float: right;
      font-size: 1.2rem;
      font-weight: bold;
      color: #333333;
      .icon {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 3px;
        width: 7vw;
        height: 2px;
        border-radius: 2px;
        background-color: #00706E;
      }
    }
    .scienceNav {
      float: left;
      font-size: 1.1rem;
      font-weight: bold;
      color: #999999;
    }
  }
  .card {
    position: relative;
    left: 5%;
    width: 90%;
    margin: 10px 0 20px 0;
    background: #ffffff;
    border: 1px solid #e1e1e1;
    border-radius: 15px;
    .IconAndName {
      margin: 8px 0 0 8px;
      .cardIcon {
        float: left;
        background: #ffffff;
        border: 1px solid #f79a37;
        border-radius: 20px;
        font-weight: 400;
        color: #f79a37;
        padding: 2px 5px;
      }
      .cardIconSchool {
        float: left;
        background: #ffffff;
        border: 1px solid #00706E;
        border-radius: 20px;
        font-weight: 400;
        color: #00706E;
        padding: 2px 5px;
      }
      .cooperationName {
        float: left;
        font-weight: bold;
        color: #333333;
        margin: 2px 0px 0px 8px;
        font-size: 1.1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
    .title {
      margin: 10px 0 5px 10px;
      font-size: 1.1rem;
      font-weight: bold;
      color: #333333;
    }
    .describe {
      margin: 10px 0 5px 10px;
      font-weight: 400;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      line-height: 1.5rem;
    }
    .date {
      margin: 10px 0 10px 10px;
      font-weight: 400;
      color: #999999;
    }
  }
  .issue {
    position: fixed;
    right: 5%;
    top: 70%;
    height: 13.5vw;
    width: 14%;
    background-color: rgb(111, 167, 251);
    border-radius: 200px;
    text-align: center;
    line-height: 13.5vw;
    color: white;
  }
}
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/achievements/Cooperation.vue